import React from 'react';
import { Col, Row } from 'react-bootstrap';
import FilterPanel from '@spark/ui-components/components/FilterPanel';
import { filterConfig, listagemConfig } from '../config/filterConfig';

const DescargasFilter = ({
  filtros,
  loading,
  onApply,
  onApplyConfiguracao,
  onConfiguracaoReady,
  podeSalvarGeral,
  configuracoesListagem,
  children
}) => (
  <Row>
    <Col md={12}>
      <FilterPanel
        filters={filterConfig}
        listagemConfig={listagemConfig}
        configuracoesListagem={configuracoesListagem}
        values={filtros}
        onApply={onApply}
        onApplyConfiguracao={onApplyConfiguracao}
        onConfiguracaoReady={onConfiguracaoReady}
        podeSalvarGeral={podeSalvarGeral}
        title="Filtros de Descargas"
        loading={loading}
        defaultCollapsed={true}
        enableAdvancedFilters
      >
        {children}
      </FilterPanel>
    </Col>
  </Row>
);

export default DescargasFilter;
